<template>
  <v-row class="justify-center">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-img
          :alt="$vuetify.lang.translator('logoAlt')"
          src="@/assets/logo.png"
          max-width="250"
          max-height="150"
          class="my-10"
          v-bind="attrs"
          v-on="on"
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular
                indeterminate
                color="grey"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </template>
      {{ $vuetify.lang.translator("appTitle") }}
    </v-tooltip>
  </v-row>
</template>

<script>
export default {
  name: "PublicLogo"
};
</script>
